"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.encrypt = void 0;
const encrypt = (palavra, flag = true) => {
    let ret = '';
    let contador = 1;
    if (palavra.length > 0) {
        for (let i = 0; i < palavra.length; i += 1) {
            let soma = 0;
            if (flag) {
                soma = palavra.charCodeAt(i) + contador;
            }
            else {
                soma = palavra.charCodeAt(i) - contador;
            }
            contador = contador >= 15 ? 1 : contador + 1;
            ret += String.fromCharCode(Math.max(soma, 0));
        }
    }
    return ret;
};
exports.encrypt = encrypt;
